import React from 'react';
import { ApButtonSecondary } from '@alixpartners/ui-components';
import { StyledModal } from './CategoryTreeModal.styles';
import { useState } from 'react';
import NewSortableTree from './SortableTree';
import { saveSideBarConfig } from 'utils/apiRequests';
import { Spinner } from 'components/LoadingIndicator/styles';
import { useContext } from 'react';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
export const CategoryTreeModal = ({
	onClose,
	title,
	maxWidth,
	suppressFooter,
}) => {
	const [newdata, setData] = useState([]);
	const [isTreeSaving, setIsTreeSaving] = useState(false);
	const { fetchSidebarData, sidebarConfig } = useContext(
		CategoryManagementContext
	);
	const handleTreeSave = () => {
		setIsTreeSaving(true);
		saveSideBarConfig(newdata)
			.then(() => {
				setIsTreeSaving(false);
				fetchSidebarData();
				onClose();
			})
			.catch(() => {
				setIsTreeSaving(false);
				onClose();
			});
	};

	return (
		<StyledModal
			maxWidth={maxWidth}
			header={title}
			footer={
				suppressFooter
					? undefined
					: () => (
							<React.Fragment>
								<ApButtonSecondary onClick={onClose}>Cancel</ApButtonSecondary>
								<ApButtonSecondary onClick={handleTreeSave}>
									{isTreeSaving && <Spinner size={24} thickness={3} />}
									Save
								</ApButtonSecondary>
							</React.Fragment>
					  )
			}
			hasClosed={onClose}
			isDismissible
			isOpen
		>
			<NewSortableTree
				sidebarConfig={sidebarConfig}
				suppressFooter
				onClose={onClose}
				setData={setData}
			/>
		</StyledModal>
	);
};
